<template>
  <div>
    <div class="LeftContent" ref="leftcontent">
      <div class="NewsCaption">
        <h4 class="CaptionTitle">
          <b>分销</b> 平台
        </h4>
        <p class="CaptionP">
          统一企业应用平台
          <br>领先的业务开发 一揽子解决方案
        </p>
      </div>
    </div>
    <div class="RightContent">
      <div class="LoginHeader">
        <div class="LoginBrand">
          <img src="@/assets/logo.png" style="height:28px;"/>

          <b>登录</b>
          <span style="font-weight:100">分销平台</span>
          <small class="SmallLogo">欢迎来到中创分销</small>
        </div>
        <div class="icon">
          <i class="fa fa-sign-in"></i>
        </div>
        <div class="LoginErrorTips">{{ErrorMessage}}</div>
        <div class="form-group m-b-15">
          <input type="text" class="form-control form-control-lg" placeholder="用户名" v-model="UserName">
        </div>
        <div class="form-group m-b-15">
          <input type="password" class="form-control form-control-lg" placeholder="密码" v-model="PassWord">
        </div>
        <div class="form-group validCode-wrap m-b-15">
          <input
            class="form-control form-control-lg validCode-input"
            placeholder="验证码"
            v-model="validCode"
          >
          <button :disabled="canSend ? false : 'disabled'" class="validCode-btn" @click="sendVerid">{{tip}}</button>
        </div>
        <div class="loginaction" @click="login()">登录</div>

        <hr>
        <p class="text-center text-grey-darker">江苏中创供应链服务有限公司 Copyright ©</p>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import Qs from 'qs';
import axios from 'axios';
import http from '@/common/http';
export default {
  name: "Login",
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      code: "",
      UserName:'',
      PassWord:"",
      ErrorMessage:'',
      validCode: '',
      tip: '发送验证码',
      canSend: false
    };
  },
  watch: {
    'UserName': {
      handler (val) {
        if (val) {
          this.canSend = true
        } else {
          this.canSend = false
        }
      }
    }
  },
  mounted() {
    if (localStorage.getItem('Authorization')) {
      this.$router.push({ name: "Home" });
    }

    this.initdata();
  },
  methods: {
    sendVerid () {
      let that = this;
      axios.post(`/user/UserController/sendValidCode`, {
        username: that.UserName
      }).then(res => {
        if (res.data.code === 200) {
          let num = 60
          that.canSend = false
          const timer = setInterval(() => {
            num--
            that.tip = `重新获取(${num}S)`
            if (num === 0) {
              clearInterval((timer))
              that.canSend = true
              that.tip = '发送验证码'
            }
          }, 1000)
        } else {
          that.$notify({
            title: '失败',
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    login(){
      let that = this;
      if(!that.UserName){
        that.$notify({
          title: '失败',
          message: '请输入用户名',
          type: 'error'
        })
        return
      }
      if(!that.PassWord){
        that.$notify({
          title: '失败',
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      if(!that.validCode){
        that.$notify({
          title: '失败',
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      const options = {
        url: "auth/login",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded",'X-Requested-With': 'XMLHttpRequest',"Access-Control-Allow-Origin":"*" },
         data: Qs.stringify({
          username: that.UserName,
          password: that.PassWord,
          systemId: 3,
          validCode: that.validCode
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code === 200) {
            localStorage.setItem("Authorization", JSON.stringify({ Authorization: response.data.data.token}));
            localStorage.setItem("userName", JSON.stringify({ userName: response.data.data.userName}));
            that.$router.push({ name: "Home" });
          } else {
            that.ErrorMessage = response.data.message;
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },

    initdata() {
      this.IdentifyingCode = Math.floor(Math.random() * 9000) + 1000;
      let that = this;

        this.$refs.leftcontent.style.height = that.fullHeight + "px";
        window.onresize = () => {
          return (() => {
		  if (this.$refs.leftcontent != undefined) {
            window.fullHeight = document.documentElement.clientHeight;
            that.fullHeight = window.fullHeight;
			this.$refs.leftcontent.style.height = that.fullHeight + "px";
			 }
          })();
        };

    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.LeftContent {
  background-image: url(../../static/img/login-bg/login-bg-11.jpg);
  float: left;
  width: calc(100% - 500px);
  background-size: cover;
  position: relative;
}
.CaptionTitle {
  color: #fff;
  font-weight: 300;
  font-size: 36px;
}
.NewsCaption {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0,
    rgba(0, 0, 0, 1) 100%
  );
  padding: 60px 60px 30px;
}
.CaptionP {
  font-size: 18px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.75);
}
.RightContent {
  float: left;
  width: 500px;
  padding: 100px 60px 0;
}
.LoginLogo {
  background: #00acac;
  border: 14px solid transparent;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.3);
  width: 28px;
  height: 28px;
  position: relative;
  font-size: 0;
  margin-right: 10px;
  border-radius: 6px;
  top: -11px;
}
.LoginBrand {
  font-size: 28px;
  color: #242a30;
}
.SmallLogo {
  color: #707478;
  font-size: 14px;
  display: block;
  font-weight: 400;
}
.clear {
  clear: both;
}
.loginaction {
  width: 100%;
  height: 46px;
  color: #fff;
  background: #00acac;
  border-color: #00acac;
  line-height: 46px;
  font-size: 16px;
  border-radius: 5px;
  font-weight: 600;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
}
.loginaction:hover {
  background: #008b8b;
}
.CodeValidate {
  color: red;
  font-size: 12px;
  line-height: 18px;
  float: left;
  padding-left: 0.5rem;
}
.LoginErrorTips{
     background: rgba(0,0,0,.4);

  text-align: left;
  border-radius: 5px;
  padding-left: 16px;
  font-size: 14px;
  color: rgba(255,255,255,.7);
  line-height: 32px;
}

.validCode-wrap {
  display: flex;
  flex-wrap: nowrap;
}
.validCode-input {
  width: calc(100% - 120px);
  border-radius: 6px 0 0 6px;
  border: none;
}
.validCode-btn {
  width: 120px;
  background: #ffffff;
  border: none;
  border-radius: 0 6px 6px 0;
  border-left: 1px solid #F2F2F2;
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
}
.validCode-btn:focus {
  outline: none;
}
.validCode-btn:disabled {
  color: #999999;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue